module.exports = __webpack_public_path__ + "bbba9b5cb7d1ccb7818032e6e5681ac0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/microphone-s.png
// module id = 2682
// module chunks = 0